import './style.scss';
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams } from "react-router-dom";

import VisualGrid from "../../components/VisualGrid";
import HeaderMenu from "../../components/Header-Menu";
import Footer from "../../components/Footer";

function App() {
  return (
    <div className="mc-film">
      <VisualGrid />
      <HeaderMenu />        
      <section className="mc-film__content">        
        <section className="mc-film__about">
          <div className="container">
            <div className="left">
              <p className="syn-label">THE synopsis OF MAGNA CARTA</p>
              <p className="syn">
              Four days before a presidential election, FBI Associate Director Krendel Voss is ordered to build a case against Charlie, a political dissenter who has become a growing problem for the White House. But when her investigation raises more questions than answers, she is called to an emergency meeting with the President and his inner circle.
              </p>
              <p className="syn">
              Inside a secluded government residence, what begins as a strategy session slowly transforms into an all-night confrontation. As politicians, law enforcement officials, and advisers struggle to resolve an increasingly volatile situation, Krendel becomes the lone voice challenging the assumptions of those around her.

              </p>
              <p className="syn">
              With careers, reputations, and the nation's future hanging in the balance, MAGNA CARTA is a tense chamber thriller where every conversation is a move in a dangerous game of power.
              </p>
            </div>
            <div className="right">
              <img src="/images/IMG_2414.jpg" />
            </div>
          </div>
        </section>

        <section className="mc-film__techdetails">
          <div className="container-details">
            <div className="details">
              <p className="tech-label">Technical Details</p>
              <div className="tech-box">
                <div className="tech-form">
                  <p className="key">RUNTIME</p>
                  <p className="value">21min</p>
                </div>
                <div className="tech-form">
                  <p className="key">GENRE</p>
                  <p className="value">Drama</p>
                </div>
                <div className="tech-form">
                  <p className="key">LANGUAGE</p>
                  <p className="value">English</p>
                </div>
                <div className="tech-form">
                  <p className="key">YEAR</p>
                  <p className="value">2026</p>
                </div>
              </div>             
            </div>            
          </div>
        </section>

        <section className="mc-film__cast">
          <div className="container-details">
            <div className="cast">
              <p className="cast-label">Cast</p>
              <div className="cast-spell">
                <div className="bundle">
                  <p className="role">PRESIDENT</p>
                  <p className="name">CHIP BRAY</p>
                </div>
                <div className="bundle">
                  <p className="role">FBI OFFICER</p>
                  <p className="name">Mumbi Kuguru</p>
                </div>
                <div className="bundle">
                  <p className="role">CONGRESSMAN</p>
                  <p className="name">Quirijn de Lang</p>
                </div>
                <div className="bundle">
                  <p className="role">ATTORNEY GENERAL</p>
                  <p className="name">John R. Bullen</p>
                </div>
                <div className="bundle">
                  <p className="role">FBI DIRECTOR</p>
                  <p className="name">Madaliene Schalet</p>
                </div>
                <div className="bundle">
                  <p className="role">CONG. CHIEF OF STAFF</p>
                  <p className="name">Hansje Görtz</p>
                </div>
                <div className="bundle">
                  <p className="role">CONG. CHIEF OF STAFF'S AIDE</p>
                  <p className="name">Ibrahim Kanj</p>
                </div>
                <div className="bundle">
                  <p className="role">ATTORNEY GENERAL'S SECRETARY</p>
                  <p className="name">Dina Sobhi</p>
                </div>
                <div className="bundle">
                  <p className="role">FBI SPECIAL AGENT</p>
                  <p className="name">Pim Polak</p>
                </div>
                <div className="bundle">
                  <p className="role">FARMER'S SON</p>
                  <p className="name">Erwan Régnaud</p>
                </div>

                <div className="bundle">
                  <p className="role">HEAD CHEF</p>
                  <p className="name">Gertjan Bennink</p>
                </div>
                <div className="bundle">
                  <p className="role">KITCHEN STAFF #1</p>
                  <p className="name">Iclal Karmen Sahin</p>
                </div>
                <div className="bundle">
                  <p className="role">KITCHEN STAFF #2</p>
                  <p className="name">Luisa Fernanda Jiménez</p>
                </div>
                <div className="bundle">
                  <p className="role">KITCHEN STAFF #3</p>
                  <p className="name">Eva Politakis</p>
                </div>
                <div className="bundle">
                  <p className="role">Chauffeur #1</p>
                  <p className="name">Gerard de Wit</p>
                </div>
                <div className="bundle">
                  <p className="role">Chauffeur #2</p>
                  <p className="name">Karanshan Yogarajah</p>
                </div>
              </div>
            </div>                      
          </div>
        </section>

        <section className="mc-film__cast">
          <div className="container-details">
            <div className="cast">
              <p className="cast-label">Crew</p>
              <div className="cast-spell">
                <div className="bundle">
                  <p className="role">DIRECTOR</p>
                  <p className="name">R' TEJA BATHULA</p>
                </div>
                <div className="bundle">
                  <p className="role">FIRST ASSISTANT DIRECTOR</p>
                  <p className="name">Milan Raimondi Dankovic</p>
                </div>
                <div className="bundle">
                  <p className="role">Producer</p>
                  <p className="name">Christopher Mulder</p>
                </div>
                <div className="bundle">
                  <p className="role">Production Assistant (PA)</p>
                  <p className="name">Brandon Minnaard</p>
                </div>
                <div className="bundle">
                  <p className="role">Original Music</p>
                  <p className="name">JEROEN MANDERS</p>
                </div>
                <div className="bundle">
                  <p className="role">EXECUTIVE PRODUCER #1</p>
                  <p className="name">Raghav Suresh Kumar</p>
                </div>
                <div className="bundle">
                  <p className="role">EXECUTIVE PRODUCER #2</p>
                  <p className="name">Sandeep Suresh Kumar</p>
                </div>
                <div className="bundle">
                  <p className="role">EXECUTIVE PRODUCER #3</p>
                  <p className="name">R' TEJA BATHULA</p>
                </div>
                <div className="bundle">
                  <p className="role">Director of photography</p>
                  <p className="name">Anantha Krishnan</p>
                </div>
                <div className="bundle">
                  <p className="role">1st Assistant Camera</p>
                  <p className="name">Tomas Delena</p>
                </div>
                <div className="bundle">
                  <p className="role">B Camera Operator</p>
                  <p className="name">Roan Poldermans</p>
                </div>             
                <div className="bundle">
                  <p className="role">B Camera 1st Assistant</p>
                  <p className="name">Melissa Lieff</p>
                </div>
                <div className="bundle">
                  <p className="role">ADDITIONAL B Camera Operator</p>
                  <p className="name">Jelle Boerma</p>
                </div>

                <div className="bundle">
                  <p className="role">SCREENPLAY</p>
                  <p className="name">R' TEJA BATHULA</p>
                </div>
                <div className="bundle">
                  <p className="role">ADDITIONAL DIALOGUE #1</p>
                  <p className="name">Suzanne van der Leeden</p>
                </div>
                <div className="bundle">
                  <p className="role">ADDITIONAL DIALOGUE #2</p>
                  <p className="name">Nick Stankevich</p>
                </div>
                <div className="bundle">
                  <p className="role">ADDITIONAL DIALOGUE #3</p>
                  <p className="name">Patrick Collins</p>
                </div>
               <div className="bundle">
                  <p className="role">Script Supervisor</p>
                  <p className="name">Suzanne van der Leeden</p>
                </div>
                <div className="bundle">
                  <p className="role">Gaffer</p>
                  <p className="name">Ruben Klumpers</p>
                </div>
                <div className="bundle">
                  <p className="role">Additional Gaffer/Best Boy #1</p>
                  <p className="name">Mitchell voor den Dag</p>
                </div>
                <div className="bundle">
                  <p className="role">Best Boy #2</p>
                  <p className="name">Sem Berger</p>
                </div>
                <div className="bundle">
                  <p className="role">Electrician #1</p>
                  <p className="name">Tesla Bain</p>
                </div>
                <div className="bundle">
                  <p className="role">Electrician #2</p>
                  <p className="name">Mart Eibrink</p>
                </div>              
                <div className="bundle">
                  <p className="role">Electrician #3</p>
                  <p className="name">Wessel Hartog</p>
                </div>
                <div className="bundle">
                  <p className="role">PRODUCTION DESIGNER</p>
                  <p className="name">Ola Bielen</p>
                </div>
                <div className="bundle">
                  <p className="role">Assistant Production Designer </p>
                  <p className="name">Nandi Rieks</p>
                </div>
                <div className="bundle">
                  <p className="role">Assistant Production Designer/Additional PRODUCTION DESIGNER #1</p>
                  <p className="name">Cherissa Harpe</p>
                </div>
                <div className="bundle">
                  <p className="role">Additional PRODUCTION DESIGNER #2</p>
                  <p className="name">Natasha Campi</p>
                </div>
                <div className="bundle">
                  <p className="role">Sound recordist #1</p>
                  <p className="name">Rasmus Enemark</p>
                </div>
                <div className="bundle">
                  <p className="role">Sound recordist #2</p>
                  <p className="name">Gilmar Beulens</p>
                </div>
                <div className="bundle">
                  <p className="role">Sound Designer</p>
                  <p className="name">Rasmus Enemark</p>
                </div>
                <div className="bundle">
                  <p className="role">Mix Engineer</p>
                  <p className="name">SHRAVAN KUMAR</p>
                </div>
                <div className="bundle">
                  <p className="role">Makeup Artist</p>
                  <p className="name">Misha van der Kroon</p>
                </div>
                <div className="bundle">
                  <p className="role">Makeup Assistant</p>
                  <p className="name">Yamila van Diejen</p>
                </div>
                <div className="bundle">
                  <p className="role">Costume Stylist</p>
                  <p className="name">Andrea Osorio Remy</p>
                </div>
                <div className="bundle">
                  <p className="role">VFX Supervisor</p>
                  <p className="name">DHARANI BALAN</p>
                </div>
                <div className="bundle">
                  <p className="role">EDITOR</p>
                  <p className="name">Sandeep Suresh Kumar</p>
                </div>
                <div className="bundle">
                  <p className="role">COLORIST</p>
                  <p className="name">Raghav Suresh Kumar</p>
                </div>              

                <div className="bundle">
                  <p className="role">DRONE pilot #1</p>
                  <p className="name">Sven de Wildt</p>
                </div>
                <div className="bundle">
                  <p className="role">DRONE pilot #2</p>
                  <p className="name">Sytse Winkel</p>
                </div>
               
                <div className="bundle">
                  <p className="role">Production Manager #1</p>
                  <p className="name">Keven Rezkallah</p>
                </div>
                <div className="bundle">
                  <p className="role">Production Manager #2</p>
                  <p className="name">Charity Ries</p>
                </div>
                 <div className="bundle">
                  <p className="role">Production Manager #3</p>
                  <p className="name">Victor Bray</p>
                </div>
                <div className="bundle">
                  <p className="role">Behind-the-Scenes Photographer #1</p>
                  <p className="name">Victor Bray</p>
                </div>
                <div className="bundle">
                  <p className="role">Behind-the-Scenes Photographer #2</p>
                  <p className="name">Merlijn Andriessen</p>
                </div>
                <div className="bundle">
                  <p className="role">Documentation Assistant</p>
                  <p className="name">Bozhidar Dimitrov</p>
                </div>
                <div className="bundle">
                  <p className="role">Location Courtesy</p>
                  <p className="name">Ab van der Wiel & Hansje Görtz</p>
                </div>
                <div className="bundle">
                  <p className="role">With Help from</p>
                  <p className="name">drone services nederland</p>
                </div>
              </div>
            </div>                      
          </div>
        </section>

        <section className="mc-film__associations">
          <div className="container-details">
            <div className="wrap-associations">
              <p className="asso-label">ACKNOWLEDGMENTS</p>
              <div className="associations">
                <div className="bundle">
                  <img src="/images/MK.jpg" />
                  <p>Ab van der Wiel</p>
                </div>
                <div className="bundle">
                  <img src="/images/INC.jpeg" />
                  <p>International Native Casting</p>
                </div>
              </div>
            </div>                      
          </div>
        </section>

        <section className="mc-film__shotwith">
          <div className="container-details">
            <div className="wrap-shotwith">
              <p className="shotwith-label">SHOT WITH</p>
              <div className="shotwith">
                <div className="bundle">
                  <img src="/images/ARRI.webp" />                 
                </div>               
              </div>
            </div>                      
          </div>
        </section>        
      </section>
      <Footer />
    </div>
  );
}

export default App;